/* AMB Bundles — Build Your Own pack builder.
   Runs only on a builder page, the only place [data-byo-data] exists.

   The price is never invented here. Each bundle is charged its own length-band
   rate from amb.byo_config; the rates sit ~5% above the equivalent set-pack rate,
   which is what makes it arithmetically impossible for this page to undercut a set
   pack, and impossible for any mix to cost more than the same hair bought singly.
   The computed total is then matched to a real variant that already carries that
   exact price, so the cart is never asked to trust a number from the browser. */
(function () {
  'use strict';

  var node = document.querySelector('[data-byo-data]');
  if (!node) return;

  var DATA;
  try { DATA = JSON.parse(node.textContent); } catch (e) { return; }

  var CSS = '' +
    '.amb-byo__cheaper{font-size:13px;color:var(--accent-ink);margin:0 0 22px;font-weight:500}' +
    '.amb-byo__err{color:#A3182B}' +
    '.amb-byo__sizes{display:flex;gap:9px;margin:0 0 26px;max-width:320px}' +
    '.amb-byo__size{flex:1;font:inherit;font-size:15px}' +
    '.amb-byo__grid{display:grid;grid-template-columns:1fr 330px;gap:34px;align-items:start}' +
    '.amb-byo__card{border:1px solid #EFE2DC;border-radius:14px;padding:16px 18px;margin-bottom:14px;background:#fff}' +
    '.amb-byo__cardhead{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:12px}' +
    '.amb-byo__cardhead b{font-size:14px;color:var(--dark)}' +
    '.amb-byo__rate{font-size:13px;color:var(--accent-ink);font-weight:600}' +
    '.amb-byo__sub{font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#A38C85;margin:0 0 7px}' +
    '.amb-byo__sum{position:sticky;top:24px;border:1px solid #EFE2DC;border-radius:14px;padding:20px;background:#FDF9F7}' +
    '.amb-byo__sumhead{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--accent-ink);font-weight:600;margin-bottom:12px}' +
    '.amb-byo__list{list-style:none;margin:0 0 14px;padding:0}' +
    '.amb-byo__list li{display:flex;justify-content:space-between;gap:10px;font-size:13.5px;color:#5A4D49;padding:6px 0;border-bottom:1px solid #F0E5E0}' +
    '.amb-byo__list li i{font-style:normal;color:#A38C85}' +
    '.amb-byo__total{display:flex;justify-content:space-between;align-items:baseline;margin:4px 0 10px;font-size:13px;color:#5A4D49}' +
    '.amb-byo__total b{font-family:"Cormorant Garamond",serif;font-size:30px;color:var(--accent-ink);font-weight:600}' +
    '.amb-byo__vs{font-size:12.5px;color:#1C6B46;margin:0 0 12px;line-height:1.5}' +
    '.amb-byo__add{width:100%}' +
    '.amb-byo__hint{font-size:13px;color:#A3182B;margin:10px 0 0}' +
    '.amb-byo__other{display:block;text-align:center;margin:12px 0 0;font-size:12.5px;color:var(--accent-ink)}' +
    '.amb-byo__fine{font-size:11.5px;color:#9A857D;margin:12px 0 0;line-height:1.55}' +
    '@media(max-width:860px){.amb-byo__grid{grid-template-columns:1fr}' +
    '.amb-byo__sum{position:static}}';

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var rowsHost = $('[data-byo-rows]');
  var listEl = $('[data-byo-list]');
  var totalEl = $('[data-byo-total]');
  var vsEl = $('[data-byo-vs]');
  var addBtn = $('[data-byo-add]');
  var hintEl = $('[data-byo-hint]');

  /* A page can lock itself to one pack size. The 3-Pack and 5-Pack each get their
     own page and their own link, so on those the toggle is not rendered at all and
     this is simply the size we run at. */
  var LOCK = (DATA.lock === '3' || DATA.lock === '5') ? parseInt(DATA.lock, 10) : null;
  var size = LOCK || 3;
  var picks = [];          /* [{texture, tier, length} | null] */

  function cfg() { return DATA[String(size)].config; }

  function bandOf(len) {
    var bands = cfg().bands, name;
    for (name in bands) {
      if (bands[name].indexOf(len) !== -1) return name;
    }
    return null;
  }

  function rateFor(pick) {
    if (!pick || !pick.length || !pick.tier) return null;
    var band = bandOf(pick.length);
    if (!band) return null;
    return cfg().rates[band][pick.tier];
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function pillRow(values, current, onPick, labelOf) {
    var grid = el('div', 'amb-opt__grid');
    grid.style.gridTemplateColumns = 'repeat(' + Math.min(values.length, 4) + ',1fr)';
    values.forEach(function (v) {
      var key = typeof v === 'object' ? v.name : v;
      var pill = el('label', 'amb-pill', labelOf ? labelOf(v) : String(v));
      pill.setAttribute('aria-checked', current === key ? 'true' : 'false');
      pill.setAttribute('role', 'button');
      pill.tabIndex = 0;
      function choose() { onPick(v); }
      pill.addEventListener('click', choose);
      pill.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
      });
      grid.appendChild(pill);
    });
    return grid;
  }

  function render() {
    rowsHost.innerHTML = '';
    var c = cfg();
    var allLengths = [];
    Object.keys(c.bands).forEach(function (b) {
      c.bands[b].forEach(function (L) { allLengths.push(L); });
    });
    allLengths.sort(function (a, b) { return a - b; });

    for (var i = 0; i < size; i++) {
      (function (idx) {
        var pick = picks[idx] || {};
        var card = el('div', 'amb-byo__card');

        var head = el('div', 'amb-byo__cardhead');
        head.appendChild(el('b', null, 'Bundle ' + (idx + 1)));
        var r = rateFor(pick);
        head.appendChild(el('span', 'amb-byo__rate', r ? '$' + r : 'choose below'));
        card.appendChild(head);

        card.appendChild(el('p', 'amb-byo__sub', 'Texture'));
        card.appendChild(pillRow(c.textures, pick.texture, function (t) {
          picks[idx] = { texture: t.name, tier: t.tier, length: pick.length };
          render();
        }, function (t) { return t.name; }));

        card.appendChild(el('p', 'amb-byo__sub', 'Length'));
        card.appendChild(pillRow(allLengths, pick.length, function (L) {
          picks[idx] = { texture: pick.texture, tier: pick.tier, length: L };
          render();
        }, function (L) { return L + '″'; }));

        rowsHost.appendChild(card);
      })(i);
    }
    summarise();
  }

  function summarise() {
    listEl.innerHTML = '';
    var total = 0, complete = true;
    for (var i = 0; i < size; i++) {
      var p = picks[i] || {};
      var r = rateFor(p);
      var li = el('li');
      if (r == null) {
        complete = false;
        li.appendChild(el('span', null, 'Bundle ' + (i + 1)));
        li.appendChild(el('i', null, 'not chosen'));
      } else {
        total += r;
        li.appendChild(el('span', null, p.length + '″ ' + p.texture));
        li.appendChild(el('i', null, '$' + r));
      }
      listEl.appendChild(li);
    }
    totalEl.textContent = complete ? '$' + total.toLocaleString() : '—';

    /* what the same hair costs one at a time, so the saving is on screen */
    if (complete) {
      var singles = 0, known = true;
      for (var j = 0; j < size; j++) {
        var q = picks[j];
        /* key matches the Liquid side, which strips the inch mark from the
           variant title: "<Product title>|<length number>" */
        var key = q.texture + ' Bundle|' + q.length;
        var v = DATA.singles[key];
        if (v == null) { known = false; break; }
        singles += v;
      }
      if (known && singles > total) {
        vsEl.textContent = 'Bought one at a time that is $' + singles.toLocaleString() +
          '. You save $' + (singles - total).toLocaleString() + '.';
        vsEl.hidden = false;
      } else {
        vsEl.hidden = true;
      }
    } else {
      vsEl.hidden = true;
    }
    return complete ? total : null;
  }

  document.querySelectorAll('[data-byo-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (LOCK) return;
      size = parseInt(btn.getAttribute('data-byo-size'), 10);
      picks = [];
      document.querySelectorAll('[data-byo-size]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      hintEl.hidden = true;
      render();
    });
  });

  addBtn.addEventListener('click', function () {
    var total = summarise();
    if (total == null) {
      hintEl.textContent = 'Choose a texture and a length for all ' + size + ' bundles.';
      hintEl.hidden = false;
      return;
    }
    var variantId = DATA[String(size)].variants[String(total)];
    if (!variantId) {
      /* should be unreachable: every reachable total has a variant. Never guess. */
      hintEl.textContent = 'That combination is not available to buy right now. Please tell us and we will fix it.';
      hintEl.hidden = false;
      if (window.console) console.error('[amb-byo] no variant for total', total, size);
      return;
    }
    var props = {};
    for (var i = 0; i < size; i++) {
      props['Bundle ' + (i + 1)] = picks[i].length + '″ ' + picks[i].texture;
    }

    hintEl.hidden = true;
    var original = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: props })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return r.json();
      })
      .then(function () {
        addBtn.disabled = false;
        addBtn.textContent = original;
        var toggle = document.querySelector('[data-cart-toggle]');
        if (toggle) toggle.click();
        else if (window.openCart) window.openCart();
      })
      .catch(function (err) {
        addBtn.disabled = false;
        addBtn.textContent = original;
        hintEl.textContent = 'Could not add to your bag. Please try again.';
        hintEl.hidden = false;
        if (window.console) console.error('[amb-byo]', err);
      });
  });

  render();
})();
